<ion-segment
  style="width: 100%"
  mode="md"
  (ionChange)="segmentChanged($event)"
  [value]="selectedTab"
>
  @if(state.isBigScreen){
  <ion-segment-button [value]="0">
    <ion-label>{{ "machinery.machines" | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [value]="1">
    <ion-label>{{ "machinery.inspections" | translate }}</ion-label>
  </ion-segment-button>
  <ion-segment-button [value]="2">
    <ion-label>{{ "machinery.usage" | translate }}</ion-label>
  </ion-segment-button>
  }@else {
  <ion-segment-button [value]="0">
    <ion-icon name="boat-outline"></ion-icon>
  </ion-segment-button>
  <ion-segment-button [value]="1">
    <ion-icon name="clipboard-outline"></ion-icon>
  </ion-segment-button>
  <ion-segment-button [value]="2">
    <ion-icon name="stats-chart-outline"></ion-icon>
  </ion-segment-button>
  }
</ion-segment>
@if(selectedTab == 0){
<lib-machine-overview></lib-machine-overview>
} @if(selectedTab == 1){
<lib-inspection-overview></lib-inspection-overview>
} @if(selectedTab == 2){
<lib-machine-usage-overview></lib-machine-usage-overview>
}
